module.exports = __webpack_public_path__ + "static/media/Toggle.2c9c104a.svg";